module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bingdao.0e9ed41a.png";